import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "iconAlt"
})
export class IconAltPipe implements PipeTransform {
  transform(type: string): string {
    switch (type) {
      case "error":
        return "Error icon";
      case "success":
        return "Success icon";
      case "info":
        return "Info icon";
      default:
        return "Info icon";
    }
  }
}